export default "__VITE_ASSET__87f5b29e__"